module.exports = __webpack_public_path__ + "static/9-projects-transforming-the-campus-b8d7a01391747e345fcc522916f0384f.jpg";